import React from 'react'
import { Query } from 'react-apollo'

import utente from 'graphql/queries/utente'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'

import Performance from './Performance'

// core components
import RegularCard from 'components/Cards/RegularCard.jsx'

import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx'


class DettaglioAgente extends React.Component {
  
  render() {
    return (
      <Query
        query={utente}
        variables={{
          where: {
            id: parseInt(this.props.match.params.id, 10)
          },
          assenzeWhere: {
            utenteId: 0
          },
          appuntamentiWhere: {
            utenteId: 0
          }
        }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data }) => {
          if (loading) return <p>Loading...</p>
          if (error) return <p>Error :(</p>
          
          return (
            <RegularCard
              cardTitle={<h3>Dettaglio agente {data.utente.nome}</h3>}
              content={
                <Performance
                  utenteId={data.utente.id}
                />
              }
            />
          )
        }}
      </Query>
    )
  }
}

export default withStyles(extendedTablesStyle)(DettaglioAgente)



// WEBPACK FOOTER //
// ./src/views/App/Agenti/DettaglioAgente.jsx